import { EditorialToolsService } from '../services/editorialToolsService';
// Hilfsfunktion zum Extrahieren von Metadaten aus einer Website-URL
export const extractMetadataFromUrl = async (url: string): Promise<{ title?: string; description?: string }> => {
  try {
    // Authentifizierten Appwrite-Redaktionsdienst verwenden.
    const data = await EditorialToolsService.call<{ title: string }>('/title', { url });
    
    // Der Dienst gibt direkt das title-Feld zurück.
    const title = data.title;
    
    // description wird von der API nicht bereitgestellt, daher undefined
    const description = undefined;
    
    return { title, description };
  } catch (error) {
    return {};
  }
};
